module.exports = __webpack_public_path__ + "static/media/img-partner.6034525a.svg";